// RGB color type

export type RGBColor = {
  a: number // alpha
  b: number // blue
  g: number // green
  r: number // red
}
